<template>
    <v-card class="scrollable-container elevation-5">
        <v-card-title class="py-3">
            <div>About VMS</div>
        </v-card-title>
        <v-card-text class="scrollable-content"></v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'AboutPape'
};
</script>

<style lang="scss"></style>
